var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 101,
    viewBox: "0 0 125 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.7 81C124.7 91.88 115.88 100.7 105 100.7L20.0003 100.7C9.12034 100.7 0.300361 91.88 0.30036 81L0.300356 15.0429L124.7 15.0429L124.7 81Z",
    fill: "white",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.302794 15.7818C0.462709 7.20421 7.46598 0.3 16.0818 0.3L108.918 0.3C117.534 0.3 124.537 7.20421 124.697 15.7818L0.302794 15.7818Z",
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9649,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2748,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5847,
    cy: 8.04088,
    r: 1.89298,
    fill: "#EBF2F9",
    stroke: "#D2DBE2",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3103 78.7828H53.69C48.2093 78.7828 43.7663 74.3398 43.7663 68.8591V64.9515C43.7663 63.4104 45.0155 62.1611 46.5566 62.1611C48.0977 62.1611 49.347 63.4104 49.347 64.9515V68.8591C49.347 71.2576 51.2913 73.202 53.6898 73.202H71.3101C73.7087 73.202 75.653 71.2576 75.653 68.8591V64.9515C75.653 63.4104 76.9023 62.1611 78.4433 62.1611C79.9844 62.1611 81.2337 63.4104 81.2337 64.9515V68.8591C81.234 74.3398 76.791 78.7828 71.3103 78.7828Z",
    fill: "#EBF2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.979 56.1748L63.9213 63.7543C63.1525 64.5851 61.848 64.5851 61.079 63.7543L58.9437 61.4613L54.0212 56.1748C52.8677 54.9322 53.7466 52.9069 55.4492 52.9069H58.0924V40.6245C58.0924 38.7572 59.2528 37.1574 60.8935 36.519C61.3878 36.3267 61.9371 36.2168 62.5 36.2168C63.7152 36.2168 64.8205 36.7111 65.6169 37.5076C66.4134 38.304 66.9077 39.4025 66.9077 40.6245V52.9069H69.5509C71.2537 52.9069 72.1324 54.9322 70.979 56.1748Z",
    fill: "#EBF2F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M63.8939 47.5862C63.8939 52.859 62.0403 57.6854 58.9439 61.4613L54.0214 56.1749C52.8679 54.9323 53.7468 52.907 55.4494 52.907H58.0926V40.6246C58.0926 38.7573 59.253 37.1575 60.8937 36.519C62.8022 39.7664 63.8939 43.5492 63.8939 47.5862Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5565 61.4744C44.639 61.4744 43.0795 63.0339 43.0795 64.9513V68.8588C43.0795 74.7091 47.8398 79.4694 53.6902 79.4694H71.3105C77.1608 79.4694 81.9205 74.7091 81.9205 68.8588V64.9513C81.9205 63.0339 80.3609 61.4744 78.4435 61.4744C76.5261 61.4744 74.9666 63.0339 74.9666 64.9513V68.8588C74.9666 70.8748 73.3267 72.5154 71.3105 72.5154H53.6902C51.6741 72.5154 50.0336 70.8748 50.0336 68.8588V64.9513C50.0336 63.0339 48.474 61.4744 46.5565 61.4744ZM53.6902 73.8886H71.3105C74.0834 73.8886 76.3396 71.6324 76.3396 68.8588V64.9513C76.3396 63.7915 77.2835 62.8474 78.4435 62.8474C79.6033 62.8474 80.5474 63.7913 80.5474 64.9513V68.8588C80.5474 73.9522 76.4041 78.0962 71.3105 78.0962H53.6902C48.5967 78.0962 44.4527 73.9522 44.4527 68.8588V64.9513C44.4527 63.7915 45.3966 62.8474 46.5566 62.8474C47.7166 62.8474 48.6606 63.7913 48.6606 64.9513V68.8588C48.6604 71.6326 50.9165 73.8886 53.6902 73.8886Z",
    fill: "#D2DBE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 35.5305C59.6921 35.5305 57.4073 37.8155 57.4073 40.6233V52.2201H55.4475C53.147 52.2201 51.9559 54.961 53.5206 56.6431L60.5731 64.2245C61.62 65.3492 63.3905 65.3393 64.4269 64.2245L71.4794 56.6436C73.0465 54.9589 71.8495 52.2199 69.5525 52.2199H67.5927V40.6233C67.5927 37.8153 65.3079 35.5305 62.5 35.5305ZM69.5525 53.5933C70.6541 53.5933 71.2254 54.9009 70.4738 55.7086L63.4213 63.2901C62.9261 63.8225 62.0799 63.8288 61.5789 63.2901L54.5264 55.7086C53.776 54.9009 54.345 53.5933 55.4477 53.5933H58.0939C58.4734 53.5933 58.7805 53.2862 58.7805 52.9067V40.6233C58.7805 38.5722 60.4492 36.9035 62.5002 36.9035C64.5512 36.9035 66.2199 38.5722 66.2199 40.6233V52.9067C66.2199 53.2862 66.527 53.5933 66.9065 53.5933H69.5525Z",
    fill: "#D2DBE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputPlaceholder);
export default __webpack_public_path__ + "static/media/input-placeholder.fa07a202813c4503645294c1e7664bbc.svg";
export { ForwardRef as ReactComponent };